// Banner.jsx
import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import { mobileWidth } from "./constants";
import { useTranslation } from 'react-i18next';

const Banner = () => {
  const { t, i18n } = useTranslation();
  return (
    <BannerWrapper>
      <BannerContainer>
        <BannerImage src="../../static/images/banner.png" alt="Banner" />
        <FlexCol>
        <h1 style={{ alignSelf:'start' }}>{t("banner_empowering_your_pay")}</h1>
          <h1 style={{ alignSelf:'end' }}>{t("banner_one_click_at_a_time")}</h1>          
          <Button onClick={() => (window.location.href = "/addsalary")}>
            {t("banner_contribute")}
          </Button>
        </FlexCol>
      </BannerContainer>
    </BannerWrapper>
  );
};

export default Banner;

const Button = styled.button`
  border: none;
  border-radius: 40px;
  width: 67%;
  padding: 16px;
  background: #394654;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease; /* Added transition for smoother animation */
  font-size: inherit;
  &:hover {
    transform: translateY(-3px); /* Move the button up by 3px */
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); /* Add a subtle shadow */
  }

  &:active {
    transform: translateY(0); /* Reset the transform on click */
    box-shadow: none; /* Remove the shadow on click */
  }
`;

const BannerWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-top: 35px; /* Space between banner and navbar */
  height :400px;
`;
const FlexCol = styled.div`
width: 30%;
  display: flex;
  flex-direction: column;
  margin: 20px;
  text-align: center;
  font-size: 16px;
  align-items: center;
  color: #394654;
  @media (max-width: ${mobileWidth}){
    z-index: 3;
    width: 75%;
    font-size: 11px;
    max-width: 650px;
  }
`;


const BannerContainer = styled.div`
  gap: 16px;
  flex-direction: row;
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 0 0 auto; 
  border: 4px solid black; 
  border-right: none; 
  background-color: ${Colors.ratibBlue};
  display: flex;
  align-items: center;
  justify-content: space-around; 
  border-width: 2px;
  @media (max-width: ${mobileWidth}){
    width: 100%;
    flex-direction: column-reverse;
    justify-content: space-between;
  }
`;

const BannerImage = styled.img`
  align-self: end;
  width: 30%; 
  z-index: 0; 
  margin-bottom: -2px;
  @media (max-width: ${mobileWidth}){
    display: flex;
    width: 95.0%;
    max-width: 350px;
    align-self: center;
  }
`;
